import { render, staticRenderFns } from "./IsResponsibleForDamagesToOthersQuestion.vue?vue&type=template&id=4852c582&scoped=true"
import script from "./IsResponsibleForDamagesToOthersQuestion.vue?vue&type=script&lang=ts"
export * from "./IsResponsibleForDamagesToOthersQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4852c582",
  null
  
)

export default component.exports